import { OfferTableRowType } from "../../types"
import dayjs from "dayjs"
import { ReactComponent as WARNING } from "../../../../assets/WarningICON.svg"
import BaseTableRow from "../../../../components/layout/BaseTableRow"
import { Tag } from "antd"
import { useNavigate } from "react-router-dom"
import { returnAddressString } from "../../../../services/functions"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"
import { useAbility } from "../../../../components/contexts/AbilityContext"

export default function OfferTableRow({ id, title, customer, status, date, amount, archived, object }: OfferTableRowType) {
    const navigate = useNavigate()
    const ability = useAbility()

    const handleClickOnRow = () => {
        if (ability.can(P.buchhaltung_read.action, P.buchhaltung_read.subject)) {
            navigate("/buchhaltung/angebote/" + id)
        }
    }
    return (
        <BaseTableRow onClick={handleClickOnRow} classProps={archived ? "opacity-40 bg-gray-100" : ""}>
            <td className="hidden sm:table-cell">
                <p className="line-clamp-1  text-center">{dayjs(date).format("DD.MM.YYYY")}</p>
            </td>
            <td>
                <p title={title} className="line-clamp-1  text-center">
                    {title}
                </p>
            </td>
            <Authorized allOf={[P.buchhaltung_read]}>
                <td>
                    <p className="line-clamp-1 text-center w-full min-w-[4rem]">{amount}</p>
                </td>
            </Authorized>
            <td className="hidden md:table-cell">
                <p title={customer?.name} className="line-clamp-1  flex justify-center text-center">
                    {customer?.softDeleteAfter && (
                        <span className="pl-2">
                            <WARNING className="w-6 h-6 text-red-700" />
                        </span>
                    )}
                    {customer?.name}
                </p>
            </td>
            <td className="hidden lg:table-cell">
                <p
                    title={object?.adress?.street + " " + object?.adress?.nr + ", " + object?.adress?.plz + " " + object?.adress?.city}
                    className="line-clamp-1  flex justify-center text-center">
                    {object?.softDeleteAfter && (
                        <span className="pr-2">
                            <WARNING className="w-6 h-6 text-red-700" />
                        </span>
                    )}
                    {object ? returnAddressString(object?.adress) : "Kein Objekt angegeben"}
                </p>
            </td>
            <td className="table-cell">
                <p className="line-clamp-1 text-sm text-center">
                    {!archived ? (
                        status === "settled" ? (
                            <Tag color="green-inverse" className="w-24 text-center">
                                Angenommen
                            </Tag>
                        ) : status === "rejected" ? (
                            <Tag color="red" className="w-24 text-center">
                                Abgelehnt
                            </Tag>
                        ) : status === "unanswered" ? (
                            <Tag color="gold" className="w-24 text-center">
                                Ausstehend
                            </Tag>
                        ) : (
                            <Tag className="w-24 text-center">Storniert</Tag>
                        )
                    ) : (
                        <Tag color="gray" className="w-24 text-center">
                            Archiviert
                        </Tag>
                    )}
                </p>
            </td>
        </BaseTableRow>
    )
}
